module.exports = __webpack_public_path__ + "img/icons BFr_14.9f94255c.svg";